export default __webpack_public_path__ + "static/media/about-introduction-banner.803ae3de.jpg";